
const filtroBusquedaAGState = {
  loading: null,
  tiposAtencion: [],
  problemasSalud: [],
  intSanitarias: [],
  tiposPrestacion: [],
  modalNuevaPrestacion: false,
  solicitudEnCurso: false,
  filtros: {
    tipoAtencion: "T",
    problemaSalud: 0,
    intervencionSanitaria: "A",
    tipoPrestacion: "T",
    codIsapre: null,
    codPrestador: "",
  },
  arancelGES: [],
  solicitudes: [],
  modalCargarBorrador: false,
  prestacionesSolicitud: [],
  idSolicitud: null,
  pageSize: 0,
  totalPage: 0,
};

export default filtroBusquedaAGState;
